export const BUSINESS_REG_ERROR = "BUSINESS_REG_ERROR";
export const RESET_BUSINESS_REG_ERROR = "RESET_BUSINESS_REG_ERROR";

export const FETCH_ONBOARDING_STARTED = "FETCH_ONBOARDING_STARTED";
export const FETCH_ONBOARDING_FAILED = "FETCH_ONBOARDING_FAILED";
export const FETCH_ONBOARDING_SUCCESS = "FETCH_ONBOARDING_SUCCESS";
export const FETCH_ONBOARDING_RESET = "FETCH_ONBOARDING_RESET";


export const FETCH_BN_APPLICATION_STARTED = "FETCH_BN_APPLICATION_STARTED";
export const FETCH_BN_APPLICATION_FAILED = "FETCH_BN_APPLICATION_FAILED";
export const FETCH_BN_APPLICATION_SUCCESS = "FETCH_BN_APPLICATION_SUCCESS";
export const FETCH_BN_APPLICATION_RESET = "FETCH_BN_APPLICATION_RESET";

export const FETCH_LLC_APPLICATION_STARTED = "FETCH_LLC_APPLICATION_STARTED";
export const FETCH_LLC_APPLICATION_FAILED = "FETCH_LLC_APPLICATION_FAILED";
export const FETCH_LLC_APPLICATION_SUCCESS = "FETCH_LLC_APPLICATION_SUCCESS";
export const FETCH_LLC_APPLICATION_RESET = "FETCH_LLC_APPLICATION_RESET";


export const FETCH_DOCUMENT_STARTED = "FETCH_DOCUMENT_STARTED";
export const FETCH_DOCUMENT_FAILED = "FETCH_DOCUMENT_FAILED";
export const FETCH_DOCUMENT_SUCCESS = "FETCH_DOCUMENT_SUCCESS";
export const FETCH_DOCUMENT_RESET = "FETCH_DOCUMENT_RESET";


export const ONBOARDING_STARTED = "ONBOARDING_STARTED";
export const ONBOARDING_FAILED = "ONBOARDING_FAILED";
export const ONBOARDING_SUCCESS = "ONBOARDING_SUCCESS";


export const APPLICATION_INIT_STARTED = "APPLICATION_INIT_STARTED";
export const APPLICATION_INIT_FAILED = "APPLICATION_INIT_FAILED";
export const APPLICATION_INIT_SUCCESS = "APPLICATION_INIT_SUCCESS";


export const APPLICATION_SUBMIT_STARTED = "APPLICATION_SUBMIT_STARTED";
export const APPLICATION_SUBMIT_FAILED = "APPLICATION_SUBMIT_FAILED";
export const APPLICATION_SUBMIT_SUCCESS = "APPLICATION_SUBMIT_SUCCESS";


export const UPDATE_BN_STARTED = "UPDATE_BN_STARTED";
export const UPDATE_BN_FAILED = "UPDATE_BN_FAILED";
export const UPDATE_BN_SUCCESS = "UPDATE_BN_SUCCESS";


export const UPDATE_LLC_STARTED = "UPDATE_LLC_STARTED";
export const UPDATE_LLC_FAILED = "UPDATE_LLC_FAILED";
export const UPDATE_LLC_SUCCESS = "UPDATE_LLC_SUCCESS";


export const UPLOAD_DOCUMENT_STARTED = "UPLOAD_DOCUMENT_STARTED";
export const UPLOAD_DOCUMENT_FAILED = "UPLOAD_DOCUMENT_FAILED";
export const UPLOAD_DOCUMENT_SUCCESS = "UPLOAD_DOCUMENT_SUCCESS";


export const INITIATE_PAYMENT_STARTED = "INITIATE_PAYMENT_STARTED";
export const INITIATE_PAYMENT_FAILED = "INITIATE_PAYMENT_FAILED";
export const INITIATE_PAYMENT_SUCCESS = "INITIATE_PAYMENT_SUCCESS";

export const VERIFY_PAYMENT_STARTED = "VERIFY_PAYMENT_STARTED";
export const VERIFY_PAYMENT_FAILED = "VERIFY_PAYMENT_FAILED";
export const VERIFY_PAYMENT_SUCCESS = "VERIFY_PAYMENT_SUCCESS";

export const SEND_OTP_FOR_BUSINESS_EMAIL_STARTED = "SEND_OTP_FOR_BUSINESS_EMAIL_STARTED";
export const SEND_OTP_FOR_BUSINESS_EMAIL_FAILED = "SEND_OTP_FOR_BUSINESS_EMAIL_FAILED";
export const SEND_OTP_FOR_BUSINESS_EMAIL_SUCCESS = "SEND_OTP_FOR_BUSINESS_EMAIL_SUCCESS";

export const VERIFY_OTP_FOR_BUSINESS_EMAIL_STARTED = "VERIFY_OTP_FOR_BUSINESS_EMAIL_STARTED";
export const VERIFY_OTP_FOR_BUSINESS_EMAIL_FAILED = "VERIFY_OTP_FOR_BUSINESS_EMAIL_FAILED";
export const VERIFY_OTP_FOR_BUSINESS_EMAIL_SUCCESS = "VERIFY_OTP_FOR_BUSINESS_EMAIL_SUCCESS";

export const CANCEL_APPLICATION_STARTED = "CANCEL_APPLICATION_STARTED";
export const CANCEL_APPLICATION_FAILED = "CANCEL_APPLICATION_FAILED";
export const CANCEL_APPLICATION_SUCCESS = "CANCEL_APPLICATION_SUCCESS";


// ---------- BUSINESS REGISTRATION V2  ----------------

export const FETCH_SUBMITTED_RECORDS_STARTED = "FETCH_SUBMITTED_RECORDS_STARTED";
export const FETCH_SUBMITTED_RECORDS_FAILED = "FETCH_SUBMITTED_RECORDS_FAILED";
export const FETCH_SUBMITTED_RECORDS_SUCCESS = "FETCH_SUBMITTED_RECORDS_SUCCESS";

export const FETCH_SAVED_RECORDS_STARTED = "FETCH_SAVED_RECORDS_STARTED";
export const FETCH_SAVED_RECORDS_FAILED = "FETCH_SAVED_RECORDS_FAILED";
export const FETCH_SAVED_RECORDS_SUCCESS = "FETCH_SAVED_RECORDS_SUCCESS";

export const FETCH_COMPLETED_RECORDS_STARTED = "FETCH_COMPLETED_RECORDS_STARTED";
export const FETCH_COMPLETED_RECORDS_FAILED = "FETCH_COMPLETED_RECORDS_FAILED";
export const FETCH_COMPLETED_RECORDS_SUCCESS = "FETCH_COMPLETED_RECORDS_SUCCESS";

export const FETCH_LOOKUP_DATA_STARTED = "FETCH_LOOKUP_DATA_STARTED";
export const FETCH_LOOKUP_DATA_FAILED = "FETCH_LOOKUP_DATA_FAILED";
export const FETCH_LOOKUP_DATA_SUCCESS = "FETCH_LOOKUP_DATA_SUCCESS";

export const FETCH_COMPANY_LOOKUP_DATA_STARTED = "FETCH_COMPANY_LOOKUP_DATA_STARTED";
export const FETCH_COMPANY_LOOKUP_DATA_FAILED = "FETCH_COMPANY_LOOKUP_DATA_FAILED";
export const FETCH_COMPANY_LOOKUP_DATA_SUCCESS = "FETCH_COMPANY_LOOKUP_DATA_SUCCESS";

export const FETCH_STATE_LOOKUP_DATA_STARTED = "FETCH_STATE_LOOKUP_DATA_STARTED";
export const FETCH_STATE_LOOKUP_DATA_FAILED = "FETCH_STATE_LOOKUP_DATA_FAILED";
export const FETCH_STATE_LOOKUP_DATA_SUCCESS = "FETCH_STATE_LOOKUP_DATA_SUCCESS";

export const FETCH_LGA_LOOKUP_DATA_STARTED = "FETCH_LGA_LOOKUP_DATA_STARTED";
export const FETCH_LGA_LOOKUP_DATA_FAILED = "FETCH_LGA_LOOKUP_DATA_FAILED";
export const FETCH_LGA_LOOKUP_DATA_SUCCESS = "FETCH_LGA_LOOKUP_DATA_SUCCESS";
